// extracted by mini-css-extract-plugin
export default {"root":"video_root__z0ucY","loader":"video_loader__YkV3h","playButton":"video_playButton__BBRUx","video":"video_video__wTorE","background":"video_background__N-wUC"};